import { Icon } from "components/index";
import React from "react";
import { Button } from "ui/index";
import { Link } from "react-router-dom";

const ButtonWithIcon = ({ icon, variant, children, href }) => {
  if (href) {
    return (
      <Link to={href}>
        <Button variant={variant}>
          <Icon icon={icon} className="w-4 h-4" />
          {children}
        </Button>
      </Link>
    );
  }

  return (
    <Button variant={variant}>
      <Icon icon={icon} className="w-4 h-4" />
      {children}
    </Button>
  );
};

export default ButtonWithIcon;
